import type { ApiConfig } from './types'

export const API_CONFIG: ApiConfig = {
  baseUrl: import.meta.env.VITE_API_URL || 'https://api.sprintspec.com',
  headers: {
    'Content-Type': 'application/json'
  }
}
